import {Environment} from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://n.api.mabble.co.za'
};
